import React from 'react';

import './CheckBox.scss';

export type CheckBoxProps = {
  id: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  size?: number;
};

export function CheckBox({
  id,
  checked,
  onChange,
  children,
  size = 24,
}: React.PropsWithChildren<CheckBoxProps>) {
  return (
    <div className="checkbox">
      <label>
        <input
          type="checkbox"
          id={id}
          name="checkbox"
          className="checkbox"
          checked={checked}
          onChange={onChange}
          style={{ width: size, height: size }}
        />
        {children}
      </label>
    </div>
  );
}
